import { B } from '../../constants/brand';
import { fmt } from '../../utils/format';
import { Btn, Modal, StatusBadge } from '../ui';

// Shown when POST /api/tasks answers 409 with a `similarTasks` payload — an
// existing open task on the same deal/detail looks like the one being created.
// Lists the match(es) and lets the user create anyway or cancel. Every web
// create path (Tasks page modal + quick-add, DealTasksPanel, promote-note)
// routes its 409 through this so the confirm-and-resubmit flow is identical.
//
// Props:
//   newTitle      — the title the user is trying to create
//   similarTasks  — array from the 409 body: { taskId, title, status, priority, dueDate, assigneeNames }
//   onConfirm     — user chose "Create anyway" → resubmit with confirmDuplicate:true
//   onCancel      — user backed out (also fires on close / backdrop / Escape)
//   busy          — the resubmit is in flight (disables buttons + shows spinner)
export const DuplicateTaskDialog = ({ newTitle, similarTasks = [], onConfirm, onCancel, busy = false }) => (
  <Modal title="Possible duplicate task" onClose={busy ? () => {} : onCancel} width={520}>
    <div style={{ fontSize: 14, color: B.text, marginBottom: 16, lineHeight: 1.5 }}>
      A task like <strong>“{newTitle}”</strong> already exists on this deal. Create it anyway?
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
      {similarTasks.map((t) => (
        <div key={t.taskId} style={{ border: `1px solid ${B.border}`, borderRadius: 8, padding: '10px 12px', background: B.surfaceMuted }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
            <span style={{ fontWeight: 600, color: B.text, fontSize: 14 }}>{t.title}</span>
            {t.status ? <StatusBadge status={t.status} /> : null}
          </div>
          <div style={{ fontSize: 12, color: B.textMd, marginTop: 4 }}>
            {[
              t.priority ? `${t.priority} priority` : null,
              t.dueDate ? `due ${fmt.date(t.dueDate)}` : null,
              t.assigneeNames ? `assigned to ${t.assigneeNames}` : null,
            ].filter(Boolean).join(' · ') || 'No details'}
          </div>
        </div>
      ))}
    </div>

    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
      <Btn variant="ghost" onClick={onCancel} disabled={busy}>Cancel</Btn>
      <Btn variant="primary" onClick={onConfirm} loading={busy}>Create anyway</Btn>
    </div>
  </Modal>
);
